var _ellipse, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.51786,
    cy: 7.5,
    rx: 7.0159,
    ry: 7.5,
    fill: "#2A4169"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5338 7.5C12.5338 10.6654 10.1645 13 7.51786 13C4.87125 13 2.50195 10.6654 2.50195 7.5C2.50195 4.33464 4.87125 2 7.51786 2C10.1645 2 12.5338 4.33464 12.5338 7.5Z",
    stroke: "#001B3B",
    strokeOpacity: 0.94,
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7897_10026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51758 5.20801V9.58301",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47168 7.39551H9.56429",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7897_10026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.0159,
    height: 7.5,
    fill: "white",
    transform: "translate(4.00977 3.64551)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.bfc72268d33d772d6c2616435d61d14e.svg";
export { ForwardRef as ReactComponent };